// Configuration for API endpoints
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://api.yugproperties.co.in',
  SITE_URL: process.env.REACT_APP_SITE_URL || 'https://yugproperties.co.in',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

export default config;
